import Layout from '@/layout'

const SystemMaintenanceRouter = {
  path: '/SystemMaintenance',
  component: Layout,
  redirect: 'noredirect',
  name: 'SystemMaintenance',
  meta: {
    title: '系统维护',
    icon: 'daohang-ziliaoguanli'
  },
  children: [
    {
      path: 'fmUser',
      component: () => import('@/views/cargo/v0/SystemMaintenance/fmUser'),
      name: 'fmUser',
      meta: { title: '用户管理' },
      roles: []
    },
    {
      path: 'businessIntelligence',
      component: () => import('@/views/cargo/v0/SystemMaintenance/businessIntelligence'),
      name: 'businessIntelligence',
      meta: { title: 'BI图表配置' },
      roles: []
    },
    {
      path: 'fmPrivilege',
      component: () => import('@/views/cargo/v0/SystemMaintenance/fmPrivilege'),
      name: 'FmPrivilege',
      meta: { title: '权限管理' },
      roles: []
    },
    {
      path: 'IpFilterConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/ipFilterConfig'),
      name: 'IpFilterConfig',
      meta: { title: 'IP过滤配置' },
      roles: []
    },
    {
      path: 'JobNoConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/jobNoConfig'),
      name: 'JobNoConfig',
      meta: { title: '单号配置' },
      roles: ['module_JobNoConfig']
    },
    {
      path: 'BasicConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/basicConfig'),
      name: 'BasicConfig',
      meta: { title: '基础配置' },
      roles: []
    },
    {
      path: 'PageUICustom',
      component: () => import('@/views/cargo/v0/SystemMaintenance/pageUICustom'),
      name: 'PageUICustom',
      meta: { title: '页面UI自定义' },
      roles: ['module_PageUICustomModule']
    },
    {
      path: 'AICustomPage',
      component: () => import('@/views/cargo/v0/SystemMaintenance/aiCustomPage'),
      name: 'AICustomPage',
      meta: { title: 'AI+自定义表单' },
      roles: ['module_AICustomPageModule']
    },
    {
      path: 'OcrConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/ocrConfig'),
      name: 'OcrConfig',
      meta: { title: 'OCR模板设置' },
      roles: []
    },
    {
      path: 'SopConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/sopConfig'),
      name: 'SopConfig',
      meta: { title: 'SOP配置管理' },
      roles: []
    },
    {
      path: 'EnterpriseInterfaceConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/components/ocr/enterpriseInterfaceConfig'),
      name: 'EnterpriseInterfaceConfig',
      meta: { title: '企业接口配置' },
      roles: []
    },
    {
      path: 'SysMsgConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/sysMsgConfig'),
      name: 'SysMsgConfig',
      meta: { title: '系统消息配置' },
      roles: ['']
    },
    {
      path: 'PrivilegeConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/privilegeConfig'),
      name: 'PrivilegeConfig',
      meta: { title: '报表配置' },
      roles: []
    },
    {
      path: 'MtCreditConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/MtCreditConfig'),
      name: 'MtCreditConfig',
      meta: { title: '信控配置' },
      roles: []
    },
    {
      path: 'SubscribePortService',
      component: () => import('@/views/cargo/v0/SystemMaintenance/subscribePortService'),
      name: 'SubscribePortService',
      meta: { title: '数据推送配置' },
      roles: []
    },
    {
      path: 'SysMenu',
      component: () => import('@/views/cargo/v0/SystemMaintenance/sysMenu'),
      name: 'SysMenu',
      meta: { title: '菜单管理' },
      roles: []
    },
    {
      path: 'SystemAutomationConfig',
      component: () => import('@/views/cargo/v0/SystemMaintenance/systemAutomationConfig'),
      name: 'SystemAutomationConfig',
      meta: { title: '系统自动化配置' },
      roles: []
    },
    {
      path: 'AdvertisingManagement',
      component: () => import('@/views/cargo/v0/SystemMaintenance/advertisingManagement'),
      name: 'AdvertisingManagement',
      meta: { title: '广告管理' },
      roles: []
    },
    {
      path: 'AdvertisingSpaceManagement',
      component: () => import('@/views/cargo/v0/SystemMaintenance/advertisingSpaceManagement'),
      name: 'AdvertisingSpaceManagement',
      meta: { title: '广告位管理' },
      roles: []
    },
    {
      path: 'PromotionData',
      component: () => import('@/views/cargo/v0/SystemMaintenance/promotionData'),
      name: 'PromotionData',
      meta: { title: '推广数据' },
      roles: []
    },
    {
      path: 'BatchMove',
      component: () => import('@/views/cargo/v0/SystemMaintenance/batchMove'),
      name: 'BatchMove',
      meta: { title: '批量迁移' },
      roles: []
    },
    {
      path: 'DocumentTemplateManagement',
      component: () => import('@/views/cargo/v0/SystemMaintenance/documentTemplateManagement/index'),
      name: 'DocumentTemplateManagement',
      meta: { title: '文档模板管理' },
      roles: ['module_DocumentTemplateManagement']
    }
  ]
}

export default SystemMaintenanceRouter
